{
  "program": [
    {
      "programTypeGuid": "D972DA85-0565-4971-B031-FC44878C6EA9",
      "element": [
        {
          "id": "engagementRegistrationId",
          "displayName": "Event ID"
        },
        {
          "id": "engagementName",
          "displayName": "Event Name"
        },
        {
          "id": "engagementSubType",
          "displayName": "Event Type"
        },
        {
          "id": "payoutMetric",
          "displayName": "Payment Type"
        }
      ],
      "hiddenElements": [
        { "name": "programType" },
        { "name": "payeeID" },
        { "name": "taxAmount" },
        { "name": "m2CategoryTypeValue" }
      ],
      "zipFolderName": "EventDetails",
      "zipExcelfileName": "EventDetails.xlsx",
      "zipExcelfileNameHeaders": [
        { "name": "EventRegistrationID", "displayName": "EventRegistrationID" },
        { "name": "EventName", "displayName": "EventName" },
        { "name": "CountryName", "displayName": "CountryName" },
        { "name": "CustomerName", "displayName": "CustomerName" },
        { "name": "PartnerName", "displayName": "PartnerName" },
        { "name": "PartnerID", "displayName": "PartnerID" },
        { "name": "RequestDate", "displayName": "RequestDate" },
        { "name": "FiscalYear", "displayName": "FiscalYear" },
        { "name": "DateSubmittedPST", "displayName": "DateSubmittedPST" },
        { "name": "EventStatus", "displayName": "EventStatus" },
        { "name": "PartnerOneID", "displayName": "PartnerOneID" },
        { "name": "PartnerLocation", "displayName": "PartnerLocation" },
        { "name": "PayeeID", "displayName": "PayeeID" },
        {
          "name": "WorkshopCompletionDate",
          "displayName": "WorkshopCompletionDate"
        },
        { "name": "POECompletionDate", "displayName": "POECompletionDate" },
        { "name": "EventCompletionDate", "displayName": "EventCompletionDate" },
        { "name": "PaymentType", "displayName": "PaymentType" },
        { "name": "Tier1PaymentAmount", "displayName": "Tier1PaymentAmount" },
        { "name": "Tier1MetDate", "displayName": "Tier1MetDate" },
        { "name": "Tier1PaidDate", "displayName": "Tier1PaidDate" },
        { "name": "Tier1MaturityDate", "displayName": "Tier1MaturityDate" },
        { "name": "Tier1MaturityStatus", "displayName": "Tier1MaturityStatus" },
        { "name": "Tier1Target", "displayName": "Tier1Target" },
        {
          "name": "Tier1MSInvoiceNumber",
          "displayName": "Tier1MSInvoiceNumber"
        },
        { "name": "Tier1MSInvoiceDate", "displayName": "Tier1MSInvoiceDate" },
        {
          "name": "Tier1PaymentCentralTransactionID",
          "displayName": "Tier1PaymentCentralTransactionID"
        },
        {
          "name": "Tier1PaymentDocumentNumber",
          "displayName": "Tier1PaymentDocumentNumber"
        },
        { "name": "Tier2PaymentAmount", "displayName": "Tier2PaymentAmount" },
        { "name": "Tier2MetDate", "displayName": "Tier2MetDate" },
        { "name": "Tier2PaidDate", "displayName": "Tier2PaidDate" },
        { "name": "Tier2MaturityDate", "displayName": "Tier2MaturityDate" },
        { "name": "Tier2MaturityStatus", "displayName": "Tier2MaturityStatus" },
        { "name": "Tier2Target", "displayName": "Tier2Target" },
        {
          "name": "Tier2MSInvoiceNumber",
          "displayName": "Tier2MSInvoiceNumber"
        },
        { "name": "Tier2MSInvoiceDate", "displayName": "Tier2MSInvoiceDate" },
        {
          "name": "Tier2PaymentCentralTransactionID",
          "displayName": "Tier2PaymentCentralTransactionID"
        },
        {
          "name": "Tier2PaymentDocumentNumber",
          "displayName": "Tier2PaymentDocumentNumber"
        },
        { "name": "CompletionDate", "displayName": "CompletionDate" }
      ]
    },
    {
      "programTypeGuid": "C5D3A897-C737-4EEC-BFC7-D9FF1FB7F315",
      "element": [
        {
          "id": "engagementRegistrationId",
          "displayName": "Engagement ID"
        },
        {
          "id": "engagementName",
          "displayName": "Engagement Name"
        },
        {
          "id": "engagementSubType",
          "displayName": "Sub Type"
        },
        {
          "id": "payoutMetric",
          "displayName": "Payout Metric"
        }
      ],
      "hiddenElements": [
        { "name": "customerTenantId" },
        { "name": "tier" },
        { "name": "maturityStatus" },
        { "name": "maturityDate" },
        { "name": "fundingAmount" },
        { "name": "amount" },
        { "name": "paymentDocumentNumber" },
        { "name": "eventKey" }
      ],
      "zipFolderName": "EngagementDetails",
      "zipExcelfileName": "EngagementDetails.xlsx",
      "zipExcelfileNameHeaders": [
        { "name": "eventKey", "displayName": "LineItemId" },
        {
          "name": "eventRegistrationId",
          "displayName": "EngagementRegistrationID"
        },
        { "name": "eventName", "displayName": "EngagementName" },
        { "name": "customerCountry", "displayName": "CountryName" },
        { "name": "customerName", "displayName": "CustomerName" },
        { "name": "partnerName", "displayName": "PartnerName" },
        { "name": "partnerId", "displayName": "PartnerID" },
        { "name": "requestDate", "displayName": "RequestDate" },
        { "name": "fiscalYear", "displayName": "FiscalYear" },
        { "name": "dateSubmittedPST", "displayName": "DateSubmittedPST" },
        { "name": "engagementStatus", "displayName": "EngagementStatus" },
        { "name": "partnerOneID", "displayName": "PartnerOneID" },
        { "name": "partnerLocation", "displayName": "PartnerLocation" },
        { "name": "payeeID", "displayName": "PayeeID" },
        { "name": "completionDate", "displayName": "WorkshopCompletionDate" },
        { "name": "poeCompletionDate", "displayName": "POECompletionDate" },
        { "name": "completionDate", "displayName": "EngagementCompletionDate" },
        { "name": "payoutMetric", "displayName": "PayoutMetric" },
        { "name": "netAmount", "displayName": "PaymentAmount" },
        { "name": "evaluatedMonth", "displayName": "EvaluatedMonth" },
        { "name": "netIncrementMAD", "displayName": "NetIncrementMAD" },
        {
          "name": "netIncrementLicenses",
          "displayName": "NetIncrementLicenses"
        },
        { "name": "maturityDate", "displayName": "MaturityDate" },
        { "name": "maturityStatus", "displayName": "MaturityStatus" },
        { "name": "target", "displayName": "Target" }
      ]
    }
  ]
}
